// check on default Array iterator
var Iterators  = require('./$.iterators')
  , ITERATOR   = require('./$.wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue2-google-maps/~/core-js/library/modules/$.is-array-iter.js
// module id = 290
// module chunks = 1